import {
  AuthMiddleware,
  UserMiddleware,
  DashboardMiddleware,
  OrderMiddleware,
  GamesMiddleware,
  WinnerMiddleware,
  NotificationMiddleware,
  MessageMiddleware,
  TransactionMiddleware,
  PrizePoolMiddleware,
} from "../middlewares";
import { takeLatest, all, takeEvery } from "redux-saga/effects";
import {
  ADD_POST,
  GET_POSTS,
  LOGOUT,
  FORGETPASSWORD,
  RESETPASSWORD,
  TRAVELPLAN,
  BUYERPLAN,
  VERIFYCODE,
  GETUSERS,
  ANDROID_GRAPH,
  GETUSERSCARDCOUNT,
  USER_GRAPH,
  UPDATEUSERSTATUS,
  GETORDERSCARDCOUNT,
  // --------------------------------------
  SIGNIN,
  GET_GAMES,
  GETFILTERGAMES,
  GET_WINNERS,
  SEND_NOTIFICATION,
  USER_STATS,
  FREE_PAID_GAMES,
  TOTAL_GAMES,
  SIGNUP_STATS,
  MESSAGE,
  REPLY_MESSAGE,
  DELETE_MESSAGE,
  PAY_IN_DETAILS_REQUEST,
  PAY_OUT_DETAILS_REQUEST,
  TRANSACTION,
  MARK_WINNER_PAID,
  GET_PRIZEPOOL_REQUEST,
  GET_PRIZEPOOL_DETAIL_REQUEST,
  UPDATE_PRIZEPOOL_DETAIL,
  GET_LUCKYDRAW_CONFIG,
  GET_LUCKYDRAW_POOLS,
  GET_LUCKYDRAW_WINNERS,
  UPDATE_LUCKYDRAW_CONFIG,
  UPDATE_LUCKYDRAW_WINNERS,
  GET_LUCKYDRAW_POOLS_DETAILS,
} from "../constants";
import { UPDATE_LUCKYDRAW_WINNERS_ENDPOINT } from "../../config/variables";

export function* Sagas() {
  yield all([
    yield takeLatest(SIGNIN, AuthMiddleware.SignIn),
    // yield takeLatest(ADD_POST, AuthMiddleware.AddPost),
    // yield takeLatest(GET_POSTS, AuthMiddleware.GetPosts),
    yield takeLatest(LOGOUT, AuthMiddleware.Logout),
    yield takeLatest(FORGETPASSWORD, AuthMiddleware.ForgetPassword),
    yield takeLatest(RESETPASSWORD, AuthMiddleware.ResetPassword),
    yield takeLatest(VERIFYCODE, AuthMiddleware.VerifyCode),
    yield takeLatest(GETUSERS, UserMiddleware.GetUsers),
    // yield takeEvery(GETUSERSCARDCOUNT, DashboardMiddleware.GetUserCardCount),
    // yield takeLatest(USER_GRAPH, DashboardMiddleware.UserGraph),
    // yield takeLatest(ANDROID_GRAPH, DashboardMiddleware.AndroidGraph),
    yield takeLatest(UPDATEUSERSTATUS, UserMiddleware.UpdateUserStatus),
    // yield takeLatest(TRAVELPLAN, UserMiddleware.TravelUser),
    // yield takeLatest(BUYERPLAN, UserMiddleware.BuyerUser),
    // yield takeLatest(GETORDERSCARDCOUNT, OrderMiddleware.GetOrdersCount)

    //============================= PPP =======================================

    yield takeLatest(GET_GAMES, GamesMiddleware.GetGames),
    yield takeLatest(GETFILTERGAMES, GamesMiddleware.GetFilterdGames),
    yield takeLatest(GET_WINNERS, WinnerMiddleware.GetWinner),
    yield takeLatest(MARK_WINNER_PAID, WinnerMiddleware.MarkWinnerPaid), // WORKING ON THIS RIGHT NOW
    // yield takeLatest(GETWINNERS_PAY_MISSED, WinnerMiddleware.GetWinner_PaymentMissed),
    // yield takeLatest(GETWINNERS_PAY_PENDING, WinnerMiddleware.GetWinner_PaymentPending),
    yield takeLatest(
      SEND_NOTIFICATION,
      NotificationMiddleware.Send_Notification
    ),
    yield takeLatest(USER_STATS, DashboardMiddleware.GetUserStats),
    yield takeLatest(FREE_PAID_GAMES, DashboardMiddleware.GetFreeAndPaidGames),
    yield takeLatest(TOTAL_GAMES, DashboardMiddleware.GetTotalGamesPLayed),
    yield takeLatest(SIGNUP_STATS, DashboardMiddleware.GetSignUp_Stats),
    yield takeLatest(MESSAGE, MessageMiddleware.GetMessages),
    yield takeLatest(REPLY_MESSAGE, MessageMiddleware.SendMessage),
    yield takeLatest(DELETE_MESSAGE, MessageMiddleware.DeleteMessage),
    yield takeLatest(
      PAY_IN_DETAILS_REQUEST,
      TransactionMiddleware.PayInDetails
    ),
    yield takeLatest(
      PAY_OUT_DETAILS_REQUEST,
      TransactionMiddleware.PayOutDetails
    ),
    yield takeLatest(GET_PRIZEPOOL_REQUEST, PrizePoolMiddleware.GetPrizePool),
    yield takeLatest(
      GET_PRIZEPOOL_DETAIL_REQUEST,
      PrizePoolMiddleware.GetPrizePoolDetail
    ),
    yield takeLatest(
      UPDATE_PRIZEPOOL_DETAIL,
      PrizePoolMiddleware.UpdatePrizePool_Detail
    ),
    yield takeLatest(
      GET_LUCKYDRAW_CONFIG,
      PrizePoolMiddleware.GetLuckydrawConfig
    ),
    yield takeLatest(
      UPDATE_LUCKYDRAW_CONFIG,
      PrizePoolMiddleware.UpdateLuckydrawConfig_Detail
    ),
    yield takeLatest(
      GET_LUCKYDRAW_POOLS,
      PrizePoolMiddleware.GetLuckydrawPools
    ),
    yield takeLatest(
      GET_LUCKYDRAW_WINNERS,
      PrizePoolMiddleware.GetLuckydrawWinners
    ),
    yield takeLatest(
      UPDATE_LUCKYDRAW_WINNERS,
      PrizePoolMiddleware.UpdateLuckydrawWinners
    ),
    yield takeLatest(
      GET_LUCKYDRAW_POOLS_DETAILS,
      PrizePoolMiddleware.GetLuckydrawPoolsDetail
    ),
  ]);
}
